import { ConfigurationState } from 'redux/reducers/initialState'

import { BaseActionType, SET_CONFIG } from '../actions/actionTypes'

export function setConfig(config: ConfigurationState): BaseActionType {
  return { type: SET_CONFIG, payload: config }
}
